/**
 * Filters an array of strings or numbers to include only those within a specified numeric range.
 *
 * @param {Array<string | number>} arr - The array to filter.
 * @param {number} minValue - The minimum numeric value for inclusion in the result.
 * @param {number} maxValue - The maximum numeric value for inclusion in the result.
 * @returns {Array<string | number>} An array containing elements from the input array that fall within the specified numeric range.
 */
export const getOptionsInRange = (arr: (string | number)[], minValue: number, maxValue: number) => {
  return arr.filter((item) => {
    // Extract the numeric part from the string (if present)
    const numberPart = parseInt(String(item).split('/')[0]);
    // Check if the numeric part is within the specified range
    return numberPart >= minValue && numberPart <= maxValue;
  });
};
